import { createTypes } from "@/store/utils";

export const FETCH_TAGS_LIST = createTypes("FETCH_TAGS_LIST");
export const FETCH_TAG = createTypes("FETCH_TAG");
export const UPDATE_TAGS = "UPDATE_TAGS";
export const CREATE_TAG = createTypes("CREATE_TAG");
export const FETCH_CONTACT_LIST = createTypes("FETCH_CONTACT_LIST");
export const FETCH_CONTACT_DETAILS_TAGS_LIST = createTypes("FETCH_CONTACT_DETAILS_TAGS_LIST");
export const FETCH_CONTACT = createTypes("FETCH_CONTACT");
export const CREATE_CONTACT = createTypes("CREATE_CONTACT");
export const EDIT_CONTACT = createTypes("EDIT_CONTACT");
export const DELETE_CONTACT = createTypes("DELETE_CONTACT");
export const DELETE_CONTACTS_BY_TAGS = createTypes("DELETE_CONTACTS_BY_TAGS");
export const UPLOAD_CSV = createTypes("UPLOAD_CSV");
export const SEND_CSV_UPLOAD_RESULTS = createTypes("SEND_CSV_UPLOAD_RESULTS");
export const FETCH_MAIL_PIECES = createTypes("FETCH_MAIL_PIECES");
export const VALIDATE_CONTACT = createTypes("VALIDATE_CONTACT");
export const RESEND_MAILPIECE = createTypes("RESEND_MAILPIECE");
export const RESEND_LETTER = createTypes("RESEND_LETTER")
export const FETCH_LETTERS_PIECES = createTypes("FETCH_LETTERS_PIECES");
export const CHANGE_SORT = "CHANGE_SORT";
export const CHANGE_FILTER = "CHANGE_FILTER";
export const CHANGE_CURRENT_PAGE = "CHANGE_CURRENT_PAGE";
export const CHANGE_ITEMS_PER_PAGE = "CHANGE_ITEMS_PER_PAGE";
export const CHANGE_DETAILS_ACTIVITY_VIEW = "CHANGE_DETAILS_ACTIVITY_VIEW";
